import * as React from 'react';
import { Helmet } from 'react-helmet';


interface MetaProps {
    canonicalUrl: string;
    description: string;
    image?: string;
    slug: string;
    title: string;
}

export const MetaTags: React.SFC<MetaProps> = (props) => {
    return (
        <Helmet>
            <title>{ props.title }</title>
            <meta name="description" content={ props.description } />
            <meta property="og:title" content={ props.title } />
            <meta property="og:type" content="article" />
            <meta property="og:url" content={ window.location.href } />
            <meta property="og:description" content={ props.description } />
            if (props.image) { <meta property="og:image" content={ props.image } /> }
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:domain" content="prezi.com" />
            <meta name="twitter:url" content={ window.location.href } />
            <meta name="twitter:title" content={ props.title } />
            <meta name="twitter:description" content="{{ meta_description }}" />
            if (props.image) { <meta name="twitter:image" content={ props.image } /> }
            <link rel="canonical" href={ props.canonicalUrl } />
        </Helmet>
    );
};



// WEBPACK FOOTER //
// ./assets/js/components/Meta.tsx